import cx from 'classnames'
import { EditorState } from 'prosemirror-state'
import { Decoration, DecorationSet } from 'prosemirror-view'
import Styles from 'proseShared/plugins/Comments/Comments.module.scss'
import { getCommentsPluginState } from './Constants'
import { State } from './Types'

export const decorationsV2 = (state: EditorState) => {
  const decorations: Decoration[] = []
  const { enabled, commentsStore }: State = getCommentsPluginState(state)

  // This is just to make it easier to work with typescript. commentsStore will
  // always be there at this point.
  if (!commentsStore || !enabled) {
    return DecorationSet.create(state.doc, decorations)
  }

  const visibleUuids = commentsStore.comments.map((comment) => comment.uuid)

  state.doc.descendants((node, pos) => {
    const commentMarks = node.marks.filter((mark) => mark.type === state.doc.type.schema.marks.comment)
    if (!commentMarks.some((mark) => visibleUuids.includes(mark.attrs.uuid))) {
      return
    }
    // Gradient auxiliary decoration
    // If the node also has a gradient mark, we create an extra
    // decoration beforehand. This creates a span around the text
    // content but inside the gradient color mark.
    const gradientMark = node.marks.find(
      (mark) => mark.type === state.doc.type.schema.marks.colored && mark.attrs.color.startsWith('linear-gradient'),
    )
    if (gradientMark != null) {
      decorations.push(
        Decoration.inline(pos, pos + node.nodeSize, {
          style: `
          background: ${gradientMark.attrs.color};
          background-clip: 'text';
          -webkit-background-clip: text;
          -moz-background-clip: text;
          -webkit-text-fill-color: transparent;
          -moz-text-fill-color: transparent;
        `,
          nodeName: 'span',
        }),
      )
    }

    // Default decoration
    const decoration =
      node.type === state.schema.nodes.smartLink
        ? Decoration.node(pos, pos + node.nodeSize, {
            class: cx(Styles.show, {
              [Styles.highlighted]: commentMarks.some((mark) => commentsStore?.highlightedUuid === mark.attrs.uuid),
              [Styles.active]: commentMarks.some((mark) => commentsStore?.selectedUuid === mark.attrs.uuid),
            }),
            nodeName: 'span',
            'data-visible': 'true',
          })
        : Decoration.inline(pos, pos + node.nodeSize, {
            class: cx(Styles.show, {
              [Styles.highlighted]: commentMarks.some((mark) => commentsStore?.highlightedUuid === mark.attrs.uuid),
              [Styles.active]: commentMarks.some((mark) => commentsStore?.selectedUuid === mark.attrs.uuid),
            }),
            nodeName: 'span',
            'data-visible': 'true',
          })
    decorations.push(decoration)
  })

  return DecorationSet.create(state.doc, decorations)
}
